/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 28/07/13
 * Time: 09:25
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.controllers').controller('CustomerFusionCtrl', ["$scope", "$rootScope", "$timeout", "dialog", "dialogsModel", "OtherPaymentTypeView", "Images",
    function ($scope, $rootScope, $timeout, dialog, dialogsModel, OtherPaymentTypeView, Images) {
        $scope.bookingStatusImage = Images.saleStatus;
        var key;
        // hook the passed data to the popin scope
        // sourceCustomerView is passed
        for (key in dialogsModel) {
            $scope[key] = dialogsModel[key];
        }
        $timeout(function () {
            angular.element('#selector-customer').trigger('focus');
        }, 250);
        $scope.customerFusion = {
            view:
                {
                    targetCustomerView: null,
                    targetCustomerLabel: ""
                }
        };
        $scope.dialog = dialog;

        $scope.cancel = function () {
            dialog.close(null);
        };
        $scope.save = function () {
            dialog.close($scope.customerFusion.view.targetCustomerView);
        };
        $scope.onCustomerSelect = function (customerView) {
            if (customerView !== $scope.sourceCustomerView)
                $scope.customerFusion.view.targetCustomerView = customerView;
        };
        $scope.onCustomerInputKeyDown = function (event) {
            var keyCode = event.which;
            //if key delete detected : clear customer
            if (keyCode == 8 || keyCode == 46)
                $scope.customerFusion.view.targetCustomerView = null;
        }
        $scope.filterOnFusion = function () {
            return function (customerView) {
                return customerView !== $scope.sourceCustomerView;
            }
        }


    }]);



// WEBPACK FOOTER //
// ./js/controllers/pro/planningPos/CustomerFusionCtrl.js